export default {
  debug: false,
  api: {
    version: '',
    protocole: 'https',
    host: 'moneyroad-api.streammind.com',
    port: '443',
    address: function () {
      return this.protocole +
      '://' +
      this.host +
      (this.port !== '' ? ':' + this.port : '') +
      '/' +
      (this.version !== '' ? this.version + '/' : '')
    }
  },
  crypto: {
    secret: 'streammind'
  }
}



// WEBPACK FOOTER //
// ./src/config/config.dev.js